
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { ExternalLink } from 'lucide-react';
import type { RoofingBrand } from '@/hooks/useRoofingBrands';

type BrandCardProps = {
  brand: RoofingBrand;
};

const BrandCard = ({ brand }: BrandCardProps) => {
  return (
    <Card className="overflow-hidden hover:shadow-lg transition-shadow h-full flex flex-col">
      <CardContent className="p-6 flex flex-col flex-grow">
        <div className="h-20 flex items-center justify-center mb-4">
          <div className="bg-gray-100 h-20 w-full rounded flex items-center justify-center">
            {brand.logo_url ? (
              <img 
                src={brand.logo_url} 
                alt={`${brand.brand_name} logo`} 
                className="max-h-16 max-w-full object-contain"
              />
            ) : (
              <span className="text-xl font-bold text-primary">{brand.brand_name}</span>
            )}
          </div>
        </div>
        
        <h3 className="text-xl font-semibold mb-3">{brand.brand_name}</h3>
        
        <div className="mb-4 flex-grow">
          <h4 className="text-sm font-medium text-gray-700 mb-2">Top Products:</h4>
          <div className="flex flex-wrap gap-1 mb-3">
            {brand.top_products.map((product, index) => (
              <Badge key={index} variant="outline" className="bg-primary/5">
                {product}
              </Badge>
            ))}
          </div>
          
          <h4 className="text-sm font-medium text-gray-700 mb-1">Warranty:</h4>
          <p className="text-sm text-gray-600 mb-3">{brand.warranty_info}</p>
        </div>
        
        <Button 
          variant="outline" 
          className="w-full flex items-center justify-center gap-2"
          onClick={() => window.open(brand.website_url, '_blank')}
        >
          Visit Website <ExternalLink className="h-4 w-4" />
        </Button>
      </CardContent>
    </Card>
  );
};

export default BrandCard;
